import { render, staticRenderFns } from "./MyScore.vue?vue&type=template&id=69c9984d&scoped=true&"
import script from "./MyScore.vue?vue&type=script&lang=js&"
export * from "./MyScore.vue?vue&type=script&lang=js&"
import style0 from "./MyScore.vue?vue&type=style&index=0&id=69c9984d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c9984d",
  null
  
)

export default component.exports